import { defineMessages } from 'react-intl';

export const chipMessages = defineMessages({
  deleteButtonLabel: {
    defaultMessage: 'Delete chip',
    description: 'Aria label used to describe the delete chip button.',
    id: 'JfsC0aOiAl7G3esV',
  },
});
